import subscriptionModule from '../subscriptionModule';

function subscriptionController($scope, $uibModal, modalService, premiumConstantsService, premiumService, premiumConstants, languageResource, subscriptionService) {
    "ngInject";

    var pageContext = premiumConstants.pageContext.subscription;
    $scope.subscriptionPageData = premiumService.getSubscriptionPageData();
    $scope.membershipStatus = { subscriptionName: null, expiration: null, renewal: null, hasSubscription: false };
    $scope.membershipManagement = { displayMessage: false };
    $scope.isIosApp = premiumService.isIosApp();
    $scope.isAndroidApp = premiumService.isAndroidApp();
    $scope.termsUrl = premiumService.getTermsPageUrl();
    $scope.privacyUrl = premiumService.getPrivacyPageUrl();
    $scope.billingSettingUrl = premiumService.getBillingSettingUrl();
    $scope.hasRecurringProduct = false;
    $scope.termsLinkStart = "<a href=\"" + premiumService.getTermsPageUrl() + "\" class=\"text-link\">";
    $scope.termsLinkEnd = "</a>";
    $scope.privacyLinkStart = "<a href=\"" + premiumService.getPrivacyPageUrl() + "\" class=\"text-link\">";
    $scope.privatyLinkEnd = "</a>";
    $scope.billingLinkStart = "<a href=\"" + premiumService.getBillingSettingUrl() + "\" class=\"text-link\">";
    $scope.billingLinkEnd = "</a>";

    $scope.initPage = function () {
        premiumService.getMembershipProducts()
            .then(feedProducts, showError);
        premiumService.getUserStatus()
            .then(function (data) {
                initUserPlan(data);
            }, function () {
                initUserPlan();
            });
    };
    $scope.initPage();

    $scope.$on(premiumConstants.events.buyButtonClicked, buyButtonClickHandler);

    function initUserPlan(data) {
        $scope.subscriptionPageData.userPlan = data && data.subscriptionProductModel;
        showMembershipStatus($scope.subscriptionPageData.userPlan);
        showMembershipManagement($scope.subscriptionPageData.userPlan);
    }

    function feedProducts(data) {
        if (!data || !data.products) {
            showError({ errorCode: premiumConstants.errorCodes.productsNotFound });
            return;
        }

        data.products.forEach((product) => {
            product.isRecurring = (product.subscriptionTypeName.toLowerCase().indexOf("onemonth") < 0);
            if (product.isRecurring) {
                $scope.hasRecurringProduct = true;
            }
        });

        $scope.subscriptionPageData.subscriptions = data.products;
    }

    function showError(error) {
        if (error.errorCode) {
            var modalData;
            switch (error.errorCode) {
                case premiumConstants.errorCodes.productsNotFound:
                case premiumConstants.errorCodes.unableToCaculateRobuxGrant:
                case premiumConstants.errorCodes.exceedRobuxGrantMax:
                    modalData = premiumConstantsService.modalParams.serverError;
                    break;
                default:
                    modalData = premiumConstantsService.modalParams.generalError;
            }
            modalService.open(modalData);
            $scope.errorMessage = error.errorMessage;
        }
    }

    function buyButtonClickHandler(event, clickedSubscription) {
        var input = premiumConstants.streamEventParams.buyBtn,
            pid = clickedSubscription.productId,
            fromPid = ($scope.subscriptionPageData.userPlan) ? $scope.subscriptionPageData.userPlan.premiumFeatureId : null,
            field = ($scope.subscriptionPageData.userPlan) ? premiumConstants.streamEventParams.active : null;

        //user doesn't have subscription and try to get one
        if (!$scope.subscriptionPageData.userPlan) {
            subscribePlan(clickedSubscription);
        }
        //has subscription but no renewal date (user cancelled the subscription, but plan haven't expired yet)
        else if (!$scope.subscriptionPageData.userPlan.renewal) {
            field = premiumConstants.streamEventParams.willExpire;
            showAlreadyCancelledPlanModal(clickedSubscription);
        }
        //has subscription and like to switch to another plan
        else {
            showSwitchPlanModal(clickedSubscription);
        }

        //send out button clicked stream event
        premiumService.sendInteractionClickEvent(pageContext, input, pid, fromPid, field);
    }

    // User has no membership, and wants to buy subscription
    function subscribePlan(product) {
        //redirect to payment page (only handle desktop, mobile is using the href link)
        if (!$scope.subscriptionPageData.isInApp) {
            var params = {
                ap: product.productId,
                page: premiumConstants.premiumFeatureType.subscription
            }
            premiumService.purchaseSubscription(params);
        }
    }

    function showAlreadyCancelledPlanModal(targetPlan) {
        premiumService.sendModalShownEvent(pageContext, targetPlan.productId, $scope.subscriptionPageData.userPlan.premiumFeatureId);
        var modal = modalService.open(premiumConstantsService.modalParams.alreadyCancelled(dateString($scope.subscriptionPageData.userPlan ? $scope.subscriptionPageData.userPlan.expiration : null)));
        modal.result
            .then(angular.noop, function () {
                premiumService.sendModalDismissedEvent(pageContext, targetPlan.productId, $scope.subscriptionPageData.userPlan.premiumFeatureId);
            });
    }

    function showSwitchPlanModal(targetPlan) {
        premiumService.sendModalShownEvent(pageContext, targetPlan.productId, $scope.subscriptionPageData.userPlan.premiumFeatureId);
        var priceText = targetPlan.price.currency.currencySymbol + targetPlan.price.amount;
        var userPlanExpiriedDate = dateString($scope.subscriptionPageData.userPlan ? $scope.subscriptionPageData.userPlan.renewal : null);
        var modal = modalService.open(premiumConstantsService.modalParams.switchPlan(priceText, userPlanExpiriedDate, premiumConstants.modals.bodyCenterCss));
        modal.result
            .then(function () { //confirm to switch 
                premiumService.sendModalClickEvent(pageContext, premiumConstants.messages.confirmLabel, targetPlan.productId, $scope.subscriptionPageData.userPlan.premiumFeatureId);
                $scope.startPatchSubscription(targetPlan);
            },
            function () { //give up switching 
                premiumService.sendModalDismissedEvent(pageContext, targetPlan.productId, $scope.subscriptionPageData.userPlan.premiumFeatureId);
            });
    }

    $scope.startPatchSubscription = function (targetPlan) {
        return premiumService.patchSubscription(targetPlan.productId)
            .then(function (newUserPlanInfo) {
                newUserPlanInfo = newUserPlanInfo.subscriptionProductModel;
                if (newUserPlanInfo.subscriptionTypeName !== $scope.subscriptionPageData.userPlan.subscriptionTypeName) {
                    $scope.subscriptionPageData.userPlan = newUserPlanInfo;
                }
            }, showError);
    }

    function dateString(dateStr) {
        if (!dateStr)
            return "";
        var date = new Date(dateStr);
        return (date instanceof Date) ? languageResource.intl.d(date, 'short') : "";
    }

    function showMembershipStatus(userPlan) {
        if (!userPlan){
            return;
        }
        $scope.membershipStatus.subscription = premiumService.getMembershipMapping(userPlan.subscriptionTypeName);
        $scope.membershipStatus.renewal = dateString(userPlan.renewal);
        $scope.membershipStatus.expiration = dateString(userPlan.expiration);
        $scope.membershipStatus.hasSubscription = true;
    }

    function showMembershipManagement(userPlan) {
        if (!userPlan || userPlan.purchasePlatform === "nonrecurring") {
            return;
        }

        var usersCurrentPlatform = premiumService.getUsersCurrentPlatform();

        if (usersCurrentPlatform !== userPlan.purchasePlatform) {
            $scope.membershipManagement.displayMessage = true;
            subscriptionService.sendEventForMembershipManagementMessaging(userPlan.purchasePlatform);
        }
    }
}
subscriptionModule
    .controller('subscriptionController', subscriptionController);

export default subscriptionController;